import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    PRODUCT_ITEMS_QUERY,
    SINGLE_PRODUCT_ITEM_QUERY,
    CREATE_PRODUCT_ITEM_MUTATION,
    UPDATE_PRODUCT_ITEM_MUTATION,
    DELETE_PRODUCT_ITEM_MUTATION
} from "@/graphql/productItems.js";

const state = {
    productItems: []
};

const getters = {};

const mutations = {
    [types.SET_PRODUCT_ITEMS](state, productItems) {
        state.productItems = productItems;
    },
    [types.SORT_PRODUCT_ITEMS](state) {
        state.productItems.sort(function(a, b) {
            // first sort by plant name, then sort by variant name
            return a.node.priority == b.node.priority
                ? 0
                : a.node.priority > b.node.priority
                ? 1
                : -1;
        });
    },
    [types.UPSERT_PRODUCT_ITEM](state, productItem) {
        var index = state.productItems.findIndex(function(element) {
            return element.node.id == productItem.id;
        });

        const node = { node: productItem };

        if (index > -1) {
            state.productItems.splice(index, 1, node);
        } else {
            state.productItems.unshift(node);
        }
    },
    [types.DELETE_PRODUCT_ITEM](state, productItem) {
        var index = state.productItems.find(function(element, index) {
            if (element.id == productItem.id) {
                return index;
            }
        });

        if (index > -1) {
            state.productItems.splice(index, 1);
        }
    }
};

const actions = {
    async fetchProductItems(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PRODUCT_ITEMS_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    const productItems =
                        response.data.tenantProductItems.edges;

                    // update store
                    context.commit(types.SET_PRODUCT_ITEMS, productItems);

                    // sort
                    context.commit(types.SORT_PRODUCT_ITEMS);

                    resolve(productItems);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleProductItem(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_PRODUCT_ITEM_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const productItem = JSON.parse(JSON.stringify(response.data.productItem));

                    // update store
                    context.commit(types.UPSERT_PRODUCT_ITEM, productItem);

                    // sort
                    context.commit(types.SORT_PRODUCT_ITEMS);

                    resolve(productItem);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createProductItem(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_PRODUCT_ITEM_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const productItem =
                        response.data.createProductItem.productItem;

                    // update store
                    context.commit(types.UPSERT_PRODUCT_ITEM, productItem);

                    // sort
                    context.commit(types.SORT_PRODUCT_ITEMS);

                    resolve(productItem);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateProductItem(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_PRODUCT_ITEM_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const productItem =
                        response.data.updateProductItem.productItem;

                    // update store
                    context.commit(types.UPSERT_PRODUCT_ITEM, productItem);

                    // sort
                    context.commit(types.SORT_PRODUCT_ITEMS);

                    resolve(productItem);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteProductItem(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_PRODUCT_ITEM_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const productItem =
                        response.data.deleteProductItem.productItem;

                    // update store
                    context.commit(types.DELETE_PRODUCT_ITEM, productItem);

                    resolve(productItem);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
